import { render } from "./PaginationArea.vue?vue&type=template&id=6c3b8c5e"
import script from "./PaginationArea.vue?vue&type=script&lang=js"
export * from "./PaginationArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__